import { render, staticRenderFns } from "./columns-36.vue?vue&type=template&id=0b45c45a&"
import script from "./columns-36.vue?vue&type=script&lang=js&"
export * from "./columns-36.vue?vue&type=script&lang=js&"
import style0 from "./columns-36.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports